import { Divider, Paper } from '@mui/material';
import { memo } from 'react';
import { ChatTestIds } from '../../../../utils/testIds/Chat.testIds';
import { useChatConfigViewsStyles } from './chatConfigViews.styles';
import ChatContainerContent from './components/ChatContainerContent/ChatContainerContent';
import ChatContainerHeader from './components/ChatContainerHeader/ChatContainerHeader';

const ChatConfigViews = () => {
  const { classes } = useChatConfigViewsStyles();

  return (
    <Paper variant="outlined" className={classes.root} test-id={ChatTestIds.CHAT_CONTAINER}>
      <ChatContainerHeader />

      <Divider />

      <ChatContainerContent />
    </Paper>
  );
};

export default memo(ChatConfigViews);
